import { useQuery } from '@tanstack/react-query';
import { getRoleManagementStats } from '../../services';

export const useAdminRoleManagementStats = (role?: string) => {
  return useQuery({
    queryKey: ['admin-role-management-stats', role],
    queryFn: () => getRoleManagementStats(role ?? ''),
    enabled: !!role,
    staleTime: 5 * 60 * 1000,
    retry: 1
  });
};
